import type { CommentParticipant } from '../types/comment-participant';
import type { CommentReadEvent } from '../types/comment-read-event';
import type { Comment } from '../types/comment';

export class ReadEventsHelper {
  static getReadEvent(readEvents: CommentReadEvent[], participant: CommentParticipant) {
    return readEvents.find((readEvent: CommentReadEvent) =>
      readEvent.participant.userId
        ? readEvent.participant.userId === participant.userId
        : readEvent.participant.recipientId === participant.recipientId
    );
  }

  static isLastReply(comment: Comment, index: number) {
    return comment.replies.length - 1 === index;
  }

  static filterOutParticpiant(
    participants: CommentParticipant[],
    participantToFilterOut: CommentParticipant
  ): CommentParticipant[] {
    return participants.filter(
      (participant: CommentParticipant) =>
        participant.recipientId !== participantToFilterOut.recipientId &&
        participant.userId !== participantToFilterOut.userId
    );
  }
}
